import { TBuildInTypes } from './src/value-validator-types';
export { validateFields, setErrorHandler_validateFields, validateOneField } from './src/validate-fields';
export { enumStrs, enumStr } from './src/run-value-validator';
export { isEmail, isPhoneNumber } from './src/run-value-validator';

declare global {
	type TValueValidator = {
		/** ? means optional, default is "?string" */
		types?: TBuildInTypes[] | TBuildInTypes;
		/** if the value is optional, then both null and empty_str are allowed */
		allow?: ('null' | 'empty_str')[];
		/** if undefined, this is the default value */
		default_value?: any;
		/** Trim the value before validation. Default true */
		str_trim?: boolean;
		str_to_upper?: boolean;
		str_to_lower?: boolean;
		/** format: 1-20 */
		str_len?: `${number}-${number}`;
		//numbers
		'<'?: number;
		'<='?: number;
		'>'?: number;
		'>='?: number;
		//
		is_email?: boolean;
		is_phone?: boolean;
		is_one_of?: string[];

		/** format: 1-20 */
		json_len?: `${number}-${number}`;

		/** format: 1-20 */
		array_len?: `${number}-${number}`;
		array_item_validator?: TValueValidator;

		object?: {
			[name: string]: TValueValidator;
		};
		// record_exists?:boolean;

		/** Put error message in "error"
		 * Return new value if necessary
		 */
		custom?: (name: string, value: any, error: string[]) => Promise<any>;
	};
}
